import api from "./axios";

class ServiceSidago {
  async cancel(idVenda) {
    const { data } = await api.get(`/report-sidago/${idVenda}`)

    return data;
  }
}

export default new ServiceSidago()